import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import useColumns from "../../hooks/useColumns";
import { Table, Card, Row, Col, Drawer,message, Modal, Spin,Form,Input,InputNumber,Select, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined, SearchOutlined,DeleteOutlined,EditOutlined, OrderedListOutlined ,FileExcelOutlined} from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Label, Legend, Tooltip, XAxis, YAxis } from "recharts";
import ExcelExport from './../ExcelExport';
import { SaveOutlined } from '@ant-design/icons';
import  getYibfEslesmeTalepList  from "../../services/yibfEslesmeTalepList";
const { Option } = Select;

const parsed = queryString.parse(history.location.search);
const { TextArea } = Input;

function onChange(value, key, record) {
  record[key] = value;
  console.log('changed', value);
}

const YibfEslesmeTalepForm = () => {
  const [form] = Form.useForm();
  const [selectionType, setSelectionType] = useState('checkbox');
  const [editingKey, setEditingKey] = useState('');
  const [spining, setSpining] = useState(false);
  const [visible, setVisible] = useState(false);
  const [yibfEslesmeTaleps,setYibfEslesmeTaleps]= useState([]);
  //const userId = parseInt(parsed.userId);
  const originData = [];
  const [dates, setDates] = useState([moment(), moment()]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  let [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleUpdate,setIsModalVisibleUpdate]=useState(false);

  useEffect(() => {
    getYibfEslesmeTalepList(1).then(res => {
        setYibfEslesmeTaleps(res.data.result);
    });
    setVisible(true);
    setSpining(false);
    setQueryDates(dates);
  }, []);

  const columns = [
    {
      title: 'Yibf No',
      dataIndex: 'yibfNo',
      width: '15%'
    },
    {
      title: 'Yapı Denetim Firması',
      dataIndex: 'iskanMuellifYapiDenetimAdi',
      width: '20%',
      editable: true,
    },
          {
      title: 'Talep Açıklama',
      dataIndex: 'talepAciklama',
      width: '15%',
      key: 'talepAciklama',
    },
    ,
    {
      title: 'Kurum Açıklama',
      dataIndex: 'kurumAciklama',
      width: '15%',
      key: 'kurumAciklama'
    },
    {
        title: 'Talep Durumu',
        dataIndex: 'eslesmeTalebiDurumAdi',
        width: '15%',
        key: 'eslesmeTalebiDurumAdi'
      },
      ,
    {
        title: 'Talep Tarihi',
        dataIndex: 'eslesmeTalebiDurumAdi',
        width: '10%',
        key: 'eslesmeTalebiDurumAdi'
      },
      {
        title: 'İşlem',
        key: 'key',
        width: '15%',
        dataIndex: 'key',
        render :(text,record)=>( record.guncellenebilirMi?
          <div>
          <TooltipAnd title="İşlem">
            <Space>
              <Label value={"Sil"}>
              </Label>
          <Button type="danger" onClick={() => { }} shape="round" icon={<DeleteOutlined/>} >İptal Et</Button>
          {/* <Button type="primary" onClick={() => { }} shape="round" icon={<EditOutlined />}>Güncelle</Button> */}
          </Space>
        </TooltipAnd>
            </div>
        :
        <Label>

        </Label>
        )
      }
  ];

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const success = (text) => {
    message.success(text);
  };
  const error = (text) => {
    message.error(text);
  };

  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const showModal = () => {

    setIsModalVisible(true);
  };

  const showModalUpdate =() => {
      setIsModalVisibleUpdate(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const openModalEslesmeTalep= ()=>{
    showModal();
  }

  const openModalEslesmeTalepUpdate=(record)=> 
  {

    showModalUpdate();
  }

const denetimSonuclariOnayla = () => {
//   setSpining(true);
//     requestModel.RequestDenetimKriteri = [];
//     for (var i = 0; i < selectedRows.length; i++) {

//         if(selectedRows[i].denetimKriteriSonucId=="2" && (selectedRows[i].aciklama=='' || selectedRows[i].aciklama==null))
//         {
//           message.warning("Denetim kriteri sonucu uygun değilse açıklama alanı doldurulmalıdır.");
//           setSpining(false);
//           return;          
//         }
//         requestModel.RequestDenetimKriteri.push({
//           "ObjectId": selectedRows[i].objectId,
//           "DenetimKriteriId": selectedRows[i].denetimKriteriId,
//           "DenetimKriteriSonucId": selectedRows[i].denetimKriteriSonucId !="0" ? parseInt(selectedRows[i].denetimKriteriSonucId) : null,
//           "Aciklama": selectedRows[i].aciklama
//         });
//       }
//         //TODO Metod çağrılacak
//         basvuruDenetimSonucKriteriGuncelle(requestModel).then(res => { res.data.success ? success('İşlem başarı ile tamamlandı.') : error(res.data.message); setSpining(false); })
//         .catch(ex => {
//           setSpining(false);
//         })
//       window.parent.location.reload(); 
    }


  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
  style={{ margin: "20px" }}
  title={<h4 style={{ fontWeight: "bolder", color: "white" }}>İskan Talep Sorgulama Formu</h4>}
  className="ant-card-head-title-large">
    <Row gutter={16}>
          {visible &&
              <Table  scroll={{ x: 1500, y: 500 }} pagination={false}  rowKey={"objectId"} bordered dataSource={yibfEslesmeTaleps}  
                columns={columns}
                title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
                </div>}
              />
          }
        </Row>
        <Row gutter={16}>{
          <Col
          span={24}
          style={{
            textAlign: 'right',
          }}
          >
        <Button
          onClick={openModalEslesmeTalep}
          type="primary"
          icon={<SaveOutlined/>}
          style={{
            marginBottom: 16,
            marginTop:8
          }}
        >
          Yeni Kayıt
        </Button>
        </Col>
        }

<Modal title="Güncelle" centered visible={isModalVisibleUpdate} footer={null}>
        <Form
      name="eslesmeTalepGuncelle"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Yibf No"
        name="yibfNo"
        rules={[{ required: true, message: 'Yibf No Zorunlu Alandır!' }]}
        value={0}
      >
        <InputNumber max={ 2147483647} min={0}  />
      </Form.Item>

      <Form.Item
        label="Açıklama"
        name="aciklama"
        rules={[{ required: true, message: 'Açıklama Zorunlu Alandır!' }]}
      >
        <TextArea rows={3} maxLength={1013} />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" on  htmlType="submit">
          Güncelle
        </Button>
      </Form.Item>
    </Form>  
        </Modal>

        <Modal title="Yeni Kayıt" centered visible={isModalVisible} footer={null} onOk={handleOk} onCancel={handleCancel}>
        <Form
      name="eslesmeTalepKayit"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Yibf No"
        name="yibfNo"
        rules={[{ required: true, message: 'Yibf No Zorunlu Alandır!' }]}
      >
        <InputNumber max={ 2147483647} min={0}  />
      </Form.Item>

      <Form.Item
        label="Açıklama"
        name="aciklama"
        rules={[{ required: true, message: 'Açıklama Zorunlu Alandır!' }]}
      >
        <TextArea rows={3} maxLength={1013} />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" on  htmlType="submit">
          Kaydet
        </Button>
      </Form.Item>
    </Form>  
        </Modal>
        </Row>
        
  </Card>
  </Spin>

}
  export default YibfEslesmeTalepForm;